var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3627 1.46991C13.8107 0.49591 13.7976 0.191895 12.2966 0.191895C11.5186 0.191895 10.7846 0.49591 10.2336 1.46991L1.95873 9.3219C1.86473 9.4149 1.79869 9.5309 1.76769 9.6579L0.731681 13.7949C0.671681 14.4199 0.743697 14.3039 0.923697 14.4829C1.1037 14.6639 1.36469 14.7359 1.61169 14.6749L5.74865 13.6409C5.87665 13.6089 5.99369 13.5429 6.88769 13.4499L14.3617 5.1749C14.9127 4.6239 15.2157 3.8899 15.2157 3.1109C15.2157 2.3309 14.9127 1.5969 14.3607 1.4599L14.3627 1.46991ZM5.84362 10.5899L11.2627 5.1709L11.7897 5.6969L6.21764 11.4659L5.84362 10.5899ZM4.81872 9.5639L3.94164 9.38892L9.71166 3.6189L10.2377 4.1459L4.81872 9.5639ZM3.8977 10.6809L4.44067 10.9679L4.72668 12.4009L2.43273 12.9749L3.8977 10.6809ZM10.7367 2.5929L11.2587 2.71991C11.8137 1.51791 12.7817 1.51791 13.3367 2.71991H13.3357C13.8897 2.62591 13.8897 3.5939 13.3357 4.1489L12.8137 4.6709L10.7367 2.5929Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/Edit-pencil.8bfa756d0923b5c2ad05577fd998c279.svg";
export { ForwardRef as ReactComponent };